module.exports = __webpack_public_path__ + "imgs/treez.163827501cd719f0faf1b00da30b9605.jpg";